import { IconProps } from '@components/Icons/Menu/index';

const defaultSize = 24;

export const ForexManagementIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 17.5H13V16.5H14C14.55 16.5 15 16.05 15 15.5V12.5C15 11.95 14.55 11.5 14 11.5H11V10.5H15V8.5H13V7.5H11V8.5H10C9.45 8.5 9 8.95 9 9.5V12.5C9 13.05 9.45 13.5 10 13.5H13V14.5H9V16.5H11V17.5ZM20 4.5H4C2.89 4.5 2.01 5.39 2.01 6.5L2 18.5C2 19.61 2.89 20.5 4 20.5H20C21.11 20.5 22 19.61 22 18.5V6.5C22 5.39 21.11 4.5 20 4.5ZM20 18.5H4V6.5H20V18.5Z"
        fill="white"
      />
    </svg>
  );
};
